import { render, staticRenderFns } from "./BillingTaskStatusTag.vue?vue&type=template&id=5169f5e2&"
import script from "./BillingTaskStatusTag.vue?vue&type=script&lang=js&"
export * from "./BillingTaskStatusTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports